var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinesImgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 429,
    height: 565,
    viewBox: "0 0 429 565",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-679 130.327C-462.909 217.492 -346.428 332.454 -279.249 426.5C-223.249 504.908 -224.243 536.981 -164.779 595.479C-35.7367 722.417 211.458 809.953 331.262 700.867C390.278 647.131 368.448 579.033 396.676 450.119C422.071 334.153 487.73 174.658 671.042 1.31934",
    stroke: "#2A71FA",
    strokeOpacity: 0.6,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-678.568 158.449C-468.384 233.362 -353.068 341.512 -285.924 429.528C-229.43 503.606 -224.836 533.229 -161.675 590.721C-29.1763 711.328 202.971 795.295 322.943 693.511C384.741 641.088 370.683 574.155 403.758 445.619C432.878 332.458 499.878 175.69 680.03 3.90625",
    stroke: "#2A71FA",
    strokeOpacity: 0.6,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-678.135 186.568C-473.861 249.231 -359.62 350.598 -292.586 432.555C-235.479 502.375 -225.528 529.481 -158.557 585.964C-22.8946 700.38 194.857 780.833 314.645 686.159C379.357 635.009 372.831 569.343 410.858 441.123C443.586 330.794 512.043 176.734 689.047 6.5127",
    stroke: "#2A71FA",
    strokeOpacity: 0.6,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-677.703 214.691C-479.34 265.104 -366.061 359.711 -299.249 435.605C-241.457 501.217 -226.336 525.76 -155.425 581.203C-16.868 689.587 187.09 766.588 306.353 678.803C374.116 628.931 374.88 564.585 417.968 436.622C454.152 329.153 524.217 177.778 698.046 9.10742",
    stroke: "#2A71FA",
    strokeOpacity: 0.6,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-677.27 242.81C-484.797 280.966 -372.368 368.825 -305.911 438.614C-247.331 500.123 -227.207 522.075 -152.33 576.446C-11.12 678.955 179.607 752.578 298.028 671.447C368.978 622.842 376.782 559.86 425.045 432.123C464.568 327.522 536.363 178.819 707.025 11.7227",
    stroke: "#2A71FA",
    strokeOpacity: 0.6,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-676.838 270.928C-490.292 296.834 -378.533 377.941 -312.574 441.64C-253.083 499.094 -228.221 518.442 -149.214 571.684C-5.56483 668.497 172.429 738.804 289.721 664.094C363.986 616.786 378.554 555.156 432.139 427.622C474.868 325.884 548.522 179.862 716.024 14.2969",
    stroke: "#2A71FA",
    strokeOpacity: 0.6,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-676.406 299.048C-495.77 312.685 -384.526 387.02 -319.237 444.669C-258.702 498.121 -229.301 514.874 -146.102 566.928C-0.188805 658.212 165.509 725.281 281.413 656.739C359.115 610.787 380.244 550.454 439.233 423.126C485.048 324.233 560.697 180.907 725.019 16.8965",
    stroke: "#2A71FA",
    strokeOpacity: 0.6,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-675.957 327.171C-501.232 328.569 -390.315 396.055 -325.883 447.696C-264.148 497.178 -230.426 511.383 -142.972 562.17C5.04485 648.101 158.84 712.003 273.123 649.383C354.382 604.861 381.8 545.744 446.345 418.626C495.106 322.561 572.843 181.963 734.021 19.4912",
    stroke: "#2A71FA",
    strokeOpacity: 0.6,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-675.541 355.289C-506.726 344.438 -395.934 405.005 -332.562 450.727C-269.444 496.25 -231.681 508.001 -139.871 557.409C10.1325 638.162 152.344 698.974 264.8 642.03C349.737 599.032 383.194 540.994 453.423 414.126C505.056 320.855 585.002 182.991 743.04 22.0859",
    stroke: "#2A71FA",
    strokeOpacity: 0.6,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-675.107 383.396C-512.199 360.296 -401.329 413.826 -339.223 453.742C-274.574 495.291 -232.966 504.658 -136.757 552.64C15.1089 628.374 146.014 686.17 256.494 634.663C345.191 593.312 384.481 536.186 460.519 409.614C514.902 319.093 597.167 184.024 752.017 24.6689",
    stroke: "#2A71FA",
    strokeOpacity: 0.6,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M-674.676 411.531C-517.659 376.177 -406.516 422.522 -345.883 456.781C-279.499 494.294 -234.3 501.459 -133.641 547.89C20.0174 618.77 139.83 673.628 248.187 627.322C340.749 587.764 385.637 531.335 467.613 405.125C524.65 317.309 609.326 185.079 761.017 27.2832",
    stroke: "#2A71FA",
    strokeOpacity: 0.6,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M-674.242 439.649C-523.155 392.042 -411.502 431.019 -352.544 459.808C-284.236 493.168 -235.658 498.357 -130.527 543.133C24.8692 609.306 133.76 661.297 239.881 619.966C336.394 582.379 386.679 526.395 474.709 400.629C534.321 315.458 621.487 186.12 770.014 29.874",
    stroke: "#2A71FA",
    strokeOpacity: 0.6,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M-673.811 467.773C-528.634 407.912 -416.318 439.3 -359.208 462.841C-288.795 491.863 -237.085 495.362 -127.411 538.376C29.6802 599.987 127.767 649.184 231.578 612.611C332.1 577.194 387.605 521.365 481.804 396.13C543.917 313.55 633.646 187.165 779.014 32.4697",
    stroke: "#2A71FA",
    strokeOpacity: 0.6,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M-673.379 495.891C-534.109 423.78 -420.991 447.336 -365.871 465.867C-293.195 490.3 -238.52 492.478 -124.306 533.614C34.4562 590.795 121.821 637.253 223.262 605.257C327.887 572.237 388.415 516.225 488.89 391.629C553.454 311.573 645.806 188.196 788.009 35.0752",
    stroke: "#2A71FA",
    strokeOpacity: 0.6,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M-672.945 524.011C-539.586 439.646 -425.568 455.114 -372.548 468.895C-297.491 488.399 -239.984 489.705 -121.196 528.857C39.2302 581.733 115.9 625.553 214.949 597.902C323.712 567.539 389.133 510.974 495.978 387.117C562.923 309.521 657.955 189.237 796.995 37.6475",
    stroke: "#2A71FA",
    strokeOpacity: 0.6,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M-672.514 552.133C-545.045 455.515 -430.107 462.626 -379.196 471.922C-301.7 486.073 -241.43 487.043 -118.068 524.096C44.0138 572.799 110 614.017 206.657 590.55C319.588 563.125 389.778 505.613 503.088 382.633C572.386 307.421 670.13 190.293 806.006 40.2578",
    stroke: "#2A71FA",
    strokeOpacity: 0.6,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M-672.061 580.252C-550.522 471.384 -434.119 483.969 -385.838 474.953C-306.865 460.202 -242.87 484.495 -114.931 519.339C48.8269 563.947 104.063 602.651 198.351 583.194C315.467 559.037 390.337 500.092 510.184 378.133C581.8 305.25 682.291 191.337 815.008 42.8682",
    stroke: "#2A71FA",
    strokeOpacity: 0.6,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M-671.646 608.371C-556.015 487.253 -438.225 488.527 -392.519 477.98C-312.409 459.497 -244.35 482.052 -111.836 514.581C53.6552 555.219 98.0563 591.453 190.046 575.837C311.335 555.273 390.829 494.454 517.28 373.624C591.199 302.998 694.452 192.369 824.005 45.4395",
    stroke: "#2A71FA",
    strokeOpacity: 0.6,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M-671.215 636.494C-561.494 503.119 -442.87 492.638 -399.182 481.008C-317.63 459.302 -245.804 479.718 -108.72 509.84C58.5091 546.565 91.9737 580.384 181.738 568.505C307.169 551.903 391.264 488.695 524.374 369.152C600.58 300.715 706.615 193.433 833.004 48.0615",
    stroke: "#2A71FA",
    strokeOpacity: 0.6,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M-670.783 664.612C-566.973 518.988 -449.459 490.452 -405.841 484.035C-319.926 471.423 -247.235 477.482 -105.604 505.074C63.4136 537.986 85.7856 569.428 173.435 561.141C302.937 548.883 391.653 482.749 531.476 364.632C609.969 298.318 718.782 194.465 842.004 50.6367",
    stroke: "#2A71FA",
    strokeOpacity: 0.6,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M-670.352 692.732C-572.452 534.858 -454.891 497.069 -412.509 487.067C-325.37 466.507 -248.658 475.347 -102.495 500.314C68.3492 529.485 79.4573 558.593 165.123 553.786C298.611 546.297 392.011 476.719 538.563 360.144C619.347 295.884 730.934 195.518 850.999 53.2441",
    stroke: "#2A71FA",
    strokeOpacity: 0.6,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M-669.918 720.855C-577.925 550.727 -460.692 503.692 -419.17 490.094C-331.311 461.309 -250.051 473.305 -99.3773 495.549C73.3453 521.046 72.9829 547.844 156.821 546.425C294.163 544.088 392.343 470.523 545.663 355.64C628.741 293.394 743.095 196.55 860.001 55.8311",
    stroke: "#2A71FA",
    strokeOpacity: 0.6,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinesImgMobile);
export default __webpack_public_path__ + "static/media/lines-img-mobile.6fe26c3199e63cda8b5c06dc9b25560c.svg";
export { ForwardRef as ReactComponent };